// extracted by mini-css-extract-plugin
export var quantityInput = "_dd-0";